import { c } from "react/compiler-runtime";
import { useCache } from "@effektify/cache";
import { isLiteralString, isLtrTag, isTrTag, isMdTag } from "@effektify/types/guards";
const useReportTranslations = () => {
  const $ = c(2);
  const {
    getTranslations
  } = useCache();
  let t0;
  if ($[0] !== getTranslations) {
    const translate = config => {
      const {
        data: translations
      } = getTranslations();
      const safeTranslations = translations || {};
      if (isLiteralString(config)) {
        return config;
      }
      if (isLtrTag(config)) {
        console.debug("Language based string/object passed to translate function", config);
        return config.values["default"] || "[Missing translation]";
      }
      if (isTrTag(config) || isMdTag(config)) {
        if (config.key !== "") {
          return safeTranslations[config.key] || `${config.key}`;
        }
        return "[Missing translation]";
      }
      return config;
    };
    t0 = {
      translate
    };
    $[0] = getTranslations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export { useReportTranslations as default };